import { useState, useEffect } from "react";
import "../Admin/admin.css";
import { NavLink } from "react-router";
import { generatePretPDF } from "./generatePretPDF";
const API = "https://suivi.amservices.eu/api";

export default function GestionMateriel() {
    const [prets, setPrets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);

    const loadPrets = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${API}/get_prets.php`, { credentials: "include" });
            const data = await res.json();
            if (data.success) setPrets(data.data);
        } catch (e) { console.error(e); }
        setLoading(false);
    };
    const imprimerBonDePret = (p) => {
        generatePretPDF(p);
    };
    useEffect(() => { loadPrets(); }, []);

    const updateEtat = async (id, etat) => {
        await fetch(`${API}/update_etat_pret.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ id, etat })
        });
        loadPrets();
    };

    const addPret = async () => {
        const nom = document.getElementById("nomClient").value;
        const tel = document.getElementById("telClient").value;
        const materiel = document.getElementById("nomMateriel").value;
        const dateRetour = document.getElementById("dateRetour").value;

        if (!nom || !materiel || !dateRetour) return alert("Veuillez remplir les champs obligatoires");

        const res = await fetch(`${API}/add_pret.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({
                client_nom: nom,
                client_tel: tel,
                materiel: materiel,
                date_retour_prevue: dateRetour
            })
        });

        const data = await res.json();
        if (data.success) {
            setShowModal(false);
            loadPrets();
        } else {
            alert("Erreur: " + data.message);
        }
    };

    // Fonction pour formater les dates proprement (JJ/MM/AAAA)
    const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        const d = new Date(dateStr);
        return d.toLocaleDateString('fr-FR');
    };

    return (
        <div className="admin-page">
            <h1>📦 Matériel Prêté</h1>
            <div className="top-actions">
                <button className="btn-add" onClick={() => setShowModal(true)}>
                    + Enregistrer un prêt
                </button>

                <NavLink to="/gestionmateriel/archives" className="btn-archive-link">
                    📦 Archives
                </NavLink>
            </div>
            {loading && <p style={{ textAlign: 'center' }}>Chargement...</p>}

            <table className="repair-table">
                <thead>
                    <tr>
                        <th>Client</th>
                        <th>Date Prêt</th>
                        <th>Matériel</th>
                        <th>Retour prévu</th>
                        <th>Statut</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {prets.map(p => {
                        const estEnRetard = new Date(p.date_retour_prevue) < new Date() && p.etat !== 'rendu';

                        return (
                            <tr key={p.id} style={{ background: estEnRetard ? '#0a6b22' : 'transparent' }}>
                                <td data-label="Client">
                                    <strong>{p.client_nom}</strong> <br />
                                    <small>{p.client_tel}</small>
                                </td>
                                <td data-label="Date Prêt">{formatDate(p.created_at)}</td>
                                <td data-label="Matériel">{p.materiel}</td>
                                <td data-label="Retour prévu" style={{ color: estEnRetard ? 'red' : 'inherit', fontWeight: estEnRetard ? 'bold' : 'normal' }}>
                                    {formatDate(p.date_retour_prevue)}
                                </td>
                                <td data-label="Statut">
                                    <select value={p.etat} onChange={(e) => updateEtat(p.id, e.target.value)}>
                                        <option value="sorti">Sorti</option>
                                        <option value="rendu">Rendu</option>
                                    </select>
                                </td>
                                <td data-label="Action">
                                    <div style={{ display: 'flex', gap: '5px' }}>
                                        <button
                                            onClick={() => imprimerBonDePret(p)}
                                            className="btn-print"
                                            style={{ background: '#00c2e8', color: 'white', border: 'none', padding: '8px', borderRadius: '5px', cursor: 'pointer' }}
                                        >
                                            🖨️ Imprimer
                                        </button>
                                        <button
                                            onClick={() => updateEtat(p.id, 'archive')}
                                            className="btn-archive"
                                        >
                                            📦 Archive
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>Nouveau Prêt</h2>
                        <input id="nomClient" placeholder="Nom du client" />
                        <input id="telClient" placeholder="Téléphone (optionnel)" />
                        <input id="nomMateriel" placeholder="Matériel (ex: PC portable n°2)" />
                        <label style={{ display: 'block', marginTop: '10px' }}>Date de retour prévue :</label>
                        <input type="date" id="dateRetour" />

                        <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                            <button className="btn-add" style={{ flex: 1 }} onClick={addPret}>Valider le prêt</button>
                            <button onClick={() => setShowModal(false)} className="btn-cancel" style={{ background: '#777', color: 'white', border: 'none', padding: '10px', borderRadius: '5px', cursor: 'pointer' }}>Annuler</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
